import styled from "styled-components";

export const SelectedOption = styled.span`
  text-transform: capitalize;
`;
